import { render, staticRenderFns } from "./TicketMedio.vue?vue&type=template&id=4dbccd9a&scoped=true"
import script from "./TicketMedio.vue?vue&type=script&lang=js"
export * from "./TicketMedio.vue?vue&type=script&lang=js"
import style0 from "./TicketMedio.vue?vue&type=style&index=0&id=4dbccd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbccd9a",
  null
  
)

export default component.exports